import React, { useState } from "react";
import styles from "./SHProducts.module.scss";

const PlaceholderIcon = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <rect x="4" y="8" width="40" height="32" rx="4" stroke="#b3b3b3" strokeWidth="2" />
    <circle cx="16" cy="18" r="3" stroke="#b3b3b3" strokeWidth="2" />
    <path d="M8 34L18 24L26 32L32 26L40 34" stroke="#b3b3b3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ProductCard = ({ product, onClick }) => {
  const [imgError, setImgError] = useState(false);
  const { productFamilyDesc, productCategory, productFamilyId } = product;
  const imageUrl = product.productFamilyImage || product.productFamilyimage;

  const showPlaceholder = !imageUrl || imgError;
  const handleClick = () => onClick?.(productFamilyId);

  return (
    <div
      className={styles.product_card}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleClick()}
    >
      <div className={styles.card_image_wrapper}>
        {showPlaceholder ? (
          <div className={styles.image_placeholder} aria-hidden="true">
            <PlaceholderIcon />
          </div>
        ) : (
          <img
            src={imageUrl}
            alt={productFamilyDesc || "Product image"}
            className={styles.card_image}
            loading="lazy"
            onError={() => setImgError(true)}
          />
        )}
      </div>

      <div className={styles.card_content}>
        <p className={styles.product_desc}>{productFamilyDesc || "—"}</p>
        <p className={styles.product_category}>{productCategory || "Uncategorized"}</p>
      </div>
    </div>
  );
};